import { Auth, API } from "aws-amplify";

async function listCloudwatch(
  botName,
  level,
  isPrevious,
  token,
  startTime,
  endTime
) {
  const queryParams = {
    level,
    limit: 500,
    startTime,
    endTime,
    isPrevious
  };

  if (token) {
    queryParams.token = token;
  }

  return API.get("prod-slippy", `/logs/${botName}/cloudwatch`, {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    queryStringParameters: queryParams
  });
}

async function listLoki(botName, level, startTime, endTime) {
  const queryParams = {
    level,
    limit: 500,
    startTime,
    endTime
  };

  return API.get("prod-slippy", `/logs/${botName}/loki`, {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    queryStringParameters: queryParams
  });
}

export { listCloudwatch, listLoki };
